var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloud4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3840,
    height: 654,
    viewBox: "0 0 3840 654",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-10 81.9962C-10 81.9962 28.1512 131.972 32.7742 150.464C32.7742 150.464 174.333 125.5 260.368 170.805C346.404 216.11 409.324 280.879 411.173 367.888C411.173 367.888 476.868 388.229 490.736 429.884L3299.58 430.809C3299.58 430.809 3321.77 416.94 3333.79 416.94L3348.58 409.543C3348.58 409.543 3368.34 335.333 3435.3 339.761C3435.3 339.761 3444.2 250.271 3508.44 199.516C3508.44 199.516 3584.55 144.576 3621.72 135.281C3621.72 135.281 3646.25 59.1734 3705.42 29.5867C3764.6 -6.48499e-05 3850 0 3850 0V505.554H-10V81.9962Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-1 521H3839V576H-1V521Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-1 595H3839V622H-1V595Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-1 641H3839V654H-1V641Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud4);
export default __webpack_public_path__ + "static/media/cloud_4.895906300b955c0b57b49ca858a28685.svg";
export { ForwardRef as ReactComponent };